// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio_radio__3xQ4P","input":"Radio_input__16SJr","inner":"Radio_inner__3Kkp1","tick":"Radio_tick__15p17"};